import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQ_ITEMS } from "@/data/cabanas";

export const Faq = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="bg-[#F9F6F0] py-24 lg:py-32"
    >
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <div className="mb-12 text-center">
          <span className="inline-flex items-center gap-3 text-xs uppercase tracking-[0.3em] text-[#5C6661] font-bold mb-6">
            <span className="w-8 h-px bg-[#2C5545]" />
            Perguntas frequentes
          </span>
          <h2 className="text-4xl sm:text-5xl font-black text-[#1A2421] tracking-tighter leading-[1.02]">
            Tudo o que você precisa saber<br />antes de chegar.
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {FAQ_ITEMS.map((item, i) => (
            <AccordionItem
              key={item.q}
              value={`item-${i}`}
              className="border-b border-[#E3DCD2]"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="text-left text-lg lg:text-xl font-semibold text-[#1A2421] py-6 hover:no-underline hover:text-[#2C5545]">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-base text-[#5C6661] leading-relaxed pb-6">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default Faq;
